import {Button} from "@/components/button/Button.tsx";
import {ButtonSize, ButtonTypography} from "@/components/button/Button.types.ts";
import {ToggleButtonProps, ToggleButtonVariant} from "@/components/toggleButton/ToggleButton.types.ts";
import classNames from "classnames";
import styles from "./ToggleButton.module.scss";

interface VariantButtonConfig {
  size?: ButtonSize;
  typography: [selected: ButtonTypography, unselected: ButtonTypography];
}

const TOGGLE_VARIANT_CONFIG: Record<ToggleButtonVariant, VariantButtonConfig> = {
  default: {typography: ["linkBold", "link"]},
  compact: {size: "compact", typography: ["linkTinyBold", "linkTiny"]},
  segmented: {size: "extraSmall", typography: ["linkBold", "link"]},
  segmentedDark: {size: "extraSmall", typography: ["normal", "normal"]},
};

export const ToggleButton = ({className, variant = "default", items, selectedId, onChange}: ToggleButtonProps) => {
  const config = TOGGLE_VARIANT_CONFIG[variant];

  return (
    <div className={classNames(styles.toggleButtonGroup, styles[variant], className)} role="radiogroup">
      {items.map(({id, label}) => (
        <Button
          key={id}
          variant={variant === "segmentedDark" ? "toggleButtonDark" : "toggleButton"}
          size={config.size}
          typography={selectedId === id ? config.typography[0] : config.typography[1]}
          onClick={() => onChange(id)}
          role="radio"
          aria-checked={selectedId === id}
          className={classNames({active: selectedId === id})}
        >
          {label}
        </Button>
      ))}
    </div>
  );
};
